import type { IdentityCardData } from "@/data/identities";
import { siteAssetPaths } from "@/lib/assets";

const TONE_BG: Record<IdentityCardData["tone"], string> = {
  forest: "bg-forest-100",
  terra: "bg-coral-100",
  gold: "bg-gold-100",
  cream: "bg-[#E1ECFA]",
};

type IdentityCardProps = {
  card: IdentityCardData;
  index: number;
  onSelect: () => void;
};

export function IdentityCard({ card, index, onSelect }: IdentityCardProps) {
  const src = siteAssetPaths.identityScene(card.id);

  return (
    <button
      type="button"
      onClick={onSelect}
      className="fade-up flex flex-col overflow-hidden rounded-[22px] bg-paper text-left shadow-card active:scale-[0.98]"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className={`relative aspect-square w-full overflow-hidden ${TONE_BG[card.tone]}`}>
        <img
          src={src}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
      </div>
      <div className="flex flex-1 flex-col px-3.5 pb-[18px] pt-4">
        <p className="text-[14.5px] font-bold leading-snug tracking-tight text-ink-900 text-balance">
          {card.title}
        </p>
        <p className="mt-1.5 text-xs leading-snug text-ink-500">{card.sub}</p>
      </div>
    </button>
  );
}
